export default [
  'HAS_CHURN_RISK',
  'HAS_ESCALATION',
  'HAS_FOLLOW_UP',
  'HAS_EXTRA_MILE',
  'HAS_DEADAIR_EXCEEDED',
  'HAS_RECORDING_DISCLOSURE_MISSING',
  'SLA_BREACH',
  'AI_AGENT_COMMUNICATION_EFFICIENCY',
  'AI_AGENT_REPETITION',
  'BOT_COMMUNICATION_EFFICIENCY',
  'BOT_REPETITION',
]
